import Vue from "vue";
import Vuex from "vuex";

const Log = {
    namespaced: true,
    state: {
        logs: [],
        mails: []
    },
    actions: {
        setMails(context, mails) {
            ontext.commit("SETMAILS", mails);
        },
        getLogMails(context, id) {
            Vue.axios.get(window.urlapi + "mails/" + id).then(
                response => {
                    if (response.data.success == true) {
                        context.commit("SETMAILS", response.data.data);
                    }
                },
            );
        },

        getLogs(context, search) {
            if (search.entity == null && search.id == null) {
                Vue.axios.get(window.urlapi + "log").then(
                    response => {
                        if (response.data.success == true) {
                            context.commit("SETLOGS", response.data.data);
                        }
                    },
                );
            } else {
                Vue.axios.get(window.urlapi + "log/" + search.entity + "/" + search.id).then(
                    response => {
                        if (response.data.success == true) {
                            context.commit("SETLOGS", response.data.data);
                        }
                    },
                );
            }

        }
    },
    mutations: {
        SETLOGS: (state, logs) => {
            state.logs = logs;
        },
        SETMAILS: (state, mails) => {
            state.mails = mails;
        },

    },
    getters: {
        logs: state => {
            return state.logs;
        },
        mails: state => {
            return state.mails
        }
    },
    modules: {}
};

export default Log;